import Vue from 'vue'
import Router from 'vue-router'

import Base from './layouts/Base'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      component: Base,
      children: [
        {
          path: 'login',
          name: 'login',
          component: () => import('./layouts/LoginLayout'),
          meta: { title: 'Login' }
        },
        {
          path: 'onboarding',
          name: 'onboarding',
          component: () => import('./layouts/OnboardingLayout')
        },
        {
          path: 'setup',
          component: () => import('./layouts/SetupLayout'),
          redirect: '/setup/welcome',
          meta: { title: 'Setup' },
          children: [
            {
              path: 'welcome',
              name: 'setup_welcome',
              meta: { title: 'Welcome' },
              component: () => import('./views/setup/Welcome')
            },
            {
              path: 'amp',
              name: 'setup_amp',
              meta: { title: 'AMP' },
              component: () => import('./views/setup/AMP')
            },
            {
              path: 'plan',
              name: 'setup_plan',
              meta: { title: 'Plan' },
              component: () => import('./views/setup/Plan')
            },
            {
              path: 'done',
              name: 'setup_done',
              meta: { title: 'Done' },
              component: () => import('./views/setup/Done')
            }
          ]
        },
        {
          path: 'home',
          name: 'home',
          meta: { title: 'Home' },
          component: () => import('./views/Home')
        },
        {
          path: 'amp',
          meta: { title: 'AMP' },
          component: () => import('./layouts/AMPLayout'),
          children: [
            {
              path: '',
              component: () => import('./views/amp/Index')
            },
            {
              path: 'settings',
              name: 'amp_settings',
              meta: { title: 'Settings' },
              component: () => import('./views/amp/Settings')
            },
            {
              path: 'reviews',
              name: 'amp_reviews',
              meta: { title: 'Reviews' },
              component: () => import('./views/amp/Reviews')
            },
            {
              path: 'customCss',
              name: 'amp_custom_css',
              meta: { title: 'Custom CSS' },
              component: () => import('./views/amp/CustomCSS')
            },
            {
              path: 'sitemap',
              name: 'amp_sitemap',
              meta: { title: 'Sitemap' },
              component: () => import('./views/amp/Sitemap')
            },
            {
              path: 'social',
              name: 'amp_social',
              meta: { title: 'Social' },
              component: () => import('./views/amp/Social')
            },
            {
              path: 'ads',
              name: 'amp_ads',
              meta: { title: 'Ads' },
              component: () => import('./views/amp/Ads')
            }
          ]
        },
        {
          path: 'amp',
          meta: { title: 'AMP' },
          component: () => import('./layouts/AMPPreviewLayout'),
          children: [
            {
              path: 'general',
              name: 'amp_general',
              meta: { title: 'General' },
              component: () => import('./views/amp/General')
            },
            {
              path: 'products',
              name: 'amp_products',
              meta: { title: 'Products' },
              component: () => import('./views/amp/Products')
            },
            {
              path: 'collections',
              name: 'amp_collections',
              meta: { title: 'Collections' },
              component: () => import('./views/amp/Collections')
            },
            {
              path: 'blogPosts',
              name: 'amp_blog_posts',
              meta: { title: 'Blog Posts' },
              component: () => import('./views/amp/BlogPosts')
            }
          ]
        },
        {
          path: 'account',
          meta: { title: 'Account' },
          component: () => import('./layouts/AccountLayout'),
          redirect: '/account/overview',
          children: [
            {
              path: 'overview',
              name: 'account_overview',
              meta: { title: 'Basic' },
              component: () => import('./views/account/Overview')
            },
            {
              path: 'plan',
              name: 'account_plan',
              meta: { title: 'Plan' },
              component: () => import('./views/account/Plan')
            }
          ]
        },
        {
          path: 'reports',
          name: 'reports',
          meta: { title: 'Reports' },
          component: () => import('./layouts/ReportsLayout'),
          redirect: '/reports/health',
          children: [
            // {
            //   path: 'pageSpeed',
            //   name: 'reports_page_speed',
            //   meta: { title: 'PageSpeed' },
            //   component: () => import('./views/reports/PageSpeed')
            // },
            {
              path: 'salesAnalytics',
              name: 'reports_sales_analytics',
              meta: { title: 'Sales & Analytics' },
              component: () => import('./views/reports/SalesAnalytics')
            },
            {
              path: 'health',
              name: 'reports_health',
              meta: { title: 'Health' },
              component: () => import('./views/reports/Health')
            }
          ]
        },
        {
          path: 'uninstall',
          meta: { title: 'Uninstall' },
          component: () => import('./layouts/SingleLayout'),
          children: [
            {
              path: '',
              name: 'uninstall',
              component: () => import('./views/Uninstall')
            }
          ]
        },
        {
          path: 'analytics',
          meta: { title: 'Analytics' },
          component: () => import('./layouts/SingleLayout'),
          children: [
            {
              path: '',
              name: 'analytics',
              component: () => import('./views/Analytics')
            }
          ]
        },
        {
          path: 'errorMonitoring',
          meta: { title: 'Error Monitoring' },
          component: () => import('./layouts/SingleLayout'),
          children: [
            {
              path: '',
              name: 'error_monitoring',
              component: () => import('./views/ErrorMonitoring')
            }
          ]
        },
        {
          path: 'help',
          meta: { title: 'Help & Support' },
          component: () => import('./layouts/SingleLayout'),
          children: [
            {
              path: '',
              name: 'help',
              component: () => import('./views/Help')
            }
          ]
        },
        {
          path: 'kraken',
          name: 'kraken',
          meta: { title: 'Kraken' },
          component: () => import('./views/Kraken')
        },
        {
          path: '*',
          name: '404',
          meta: { title: 'Page Not Found' },
          component: () => import('./layouts/NotFoundLayout'),
          beforeEnter: (to, from, next) => {
            if (to.path === '/') {
              next({ name: 'home' })
            } else {
              next()
            }
          }
        }
      ]
    }
  ]
})
